import { getLayoutSlots, getSlotCount, TEMPLATES } from "@/lib/layouts";

/**
 * Wireframe preview shown in Step 1 — no images, just the layout grid.
 */
export default function LayoutWireframe({ templateId, photosPerPage, pageCount }) {
  const slots = getSlotCount(templateId, photosPerPage);
  const rects = getLayoutSlots(templateId, slots);
  const tmpl = TEMPLATES[templateId] || TEMPLATES.auto;

  return (
    <div className="w-full">
      <div className="flex items-baseline justify-between mb-3">
        <div className="text-xs uppercase tracking-[0.25em] font-semibold text-slate-500">
          Wireframe preview
        </div>
        <div className="text-xs text-slate-500">
          A4 · {slots} slot{slots === 1 ? "" : "s"} · {tmpl.label}
        </div>
      </div>
      <div className="a4-ratio bg-white rounded-2xl sb-hairline sb-shadow relative overflow-hidden max-w-md mx-auto">
        <div className="absolute inset-[3%]">
          <div className="relative w-full h-full">
            {rects.map((s, i) => (
              <div
                key={i}
                className="absolute"
                style={{
                  left: s.left,
                  top: s.top,
                  width: s.width,
                  height: s.height,
                  padding: "3px",
                }}
              >
                <div className="w-full h-full border-2 border-dashed border-[#299fe0]/60 bg-[#299fe0]/5 rounded-lg flex items-center justify-center text-[#299fe0]/70 text-[11px] font-semibold">
                  Slot {i + 1}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-3 text-center text-xs text-slate-500">
        Preview shows layout for a single page. Total pages: {pageCount}.
      </div>
    </div>
  );
}
